import React from 'react';
export class ModalHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'flex items-center mb-4 text-lg font-semibold text-base-300', style: this.props.style }, this.props.children)));
        };
    }
}
